import { model as i18n } from '!/i18n'
import { model as cartModel } from '$/cart'
import { model as paymentInfoModel } from '$/payment-info'
import { model as priceSettingsModel } from '$/price-settings'
import { model as redirectUrlModel } from '$/redirect-url'
import { type LiveEvent } from '@setplex/tria-api'
import { createEvent, sample } from 'effector'
import { aye } from '~/shared/helpers'
import { anyPaymentInitiated } from './model'

export const selectLiveEventPaymentButton = createEvent<LiveEvent>()

export const payForLiveEvent = createEvent<LiveEvent>()

sample({
  clock: selectLiveEventPaymentButton,
  filter: aye,
  fn: (liveEvent) => ({
    id: liveEvent!.id,
  }),
  target: redirectUrlModel.saveLiveEventRedirectUrl,
})

sample({
  clock: selectLiveEventPaymentButton,
  filter: aye,
  fn: (liveEvent) => liveEvent!,
  target: payForLiveEvent,
})

sample({
  clock: payForLiveEvent,
  fn: ({ priceSettings }) => priceSettings || null,
  target: priceSettingsModel.$priceSettings,
})

sample({
  clock: payForLiveEvent,
  target: anyPaymentInitiated,
})

sample({
  clock: payForLiveEvent,
  source: i18n.$t,
  fn: ({ t }, liveEvent) => {
    const labels = [
      liveEvent.formattedStartTime,
      liveEvent.ageRatings,
      liveEvent.duration,
    ].filter(Boolean) as string[]

    return {
      name: liveEvent.name!,
      title: t('event_one'),
      imageUrl: liveEvent.bannerPosterUrl,
      labels: labels?.length > 0 ? labels : null,
      priceSettings: liveEvent.priceSettings || null,
    }
  },
  target: paymentInfoModel.$uiPaymentInfo,
})

sample({
  clock: payForLiveEvent,
  fn: (liveEvent) => ({
    liveEventId: liveEvent.id,
  }),
  target: cartModel.$liveEventInfoForCart,
})
